import { createReducer, on } from "@ngrx/store";
import { CustomerProviderCredentialsOutput } from "../../../models/load_curves.model";
import { StateTypes } from "../../../models/state-types";
import { loadCurvesActions } from "../load_curves.actions";

export interface ProvidersCredentialsState {
    providers_credentials: CustomerProviderCredentialsOutput[]|null,
    providers_credentials_state: StateTypes

    single_provider_credentials: CustomerProviderCredentialsOutput|null,
    single_provider_credentials_state: StateTypes
}

export const initialState: ProvidersCredentialsState = {
    providers_credentials: null,
    providers_credentials_state: 'pending',

    single_provider_credentials: null,
    single_provider_credentials_state: 'pending'
};

export const providersCredentialsReducer = createReducer(
    initialState,

    on(loadCurvesActions.getCustomerProviderCredentials, (state) => ({
        ...state,
        providers_credentials: null,
        providers_credentials_state: 'loading' as const
    })),
    on(loadCurvesActions.getCustomerProviderCredentialsSuccess, (state, {data}) => ({
        ...state,
        providers_credentials: data,
        providers_credentials_state: 'loaded' as const
    })),
    on(loadCurvesActions.getCustomerProviderCredentialsFail, (state) => ({
        ...state,
        providers_credentials: null,
        providers_credentials_state: 'error' as const
    })),

    on(loadCurvesActions.getSingleCustomerProviderCredentials, (state) => ({
        ...state,
        single_provider_credentials: null,
        single_provider_credentials_state: 'loading' as const
    })),
    on(loadCurvesActions.getSingleCustomerProviderCredentialsSuccess, (state, {data}) => ({
        ...state,
        single_provider_credentials: data,
        single_provider_credentials_state: 'loaded' as const
    })),
    on(loadCurvesActions.getSingleCustomerProviderCredentialsFail, (state) => ({
        ...state,
        single_provider_credentials: null,
        single_provider_credentials_state: 'error' as const
    })),
)